import React from "react";
import { Stack, Typography, Box } from "@mui/material";

const GeneralManagerMessageAr: React.FC = () => {
  return (
    <div className="container">
      <div className="order-lg-2 max-mb-50">
        <Stack gap={3} sx={{ mt: 6, mb: 6 }}>
          <Typography
            variant="h2"
            color="primary"
            sx={{
              fontWeight: "bold",
              textAlign: "center",
              fontSize: { xs: "1.8rem", sm: "2.5rem" },
            }}
          >
            كلمة المدير العام
          </Typography>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              my: 3,
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", sm: 400 },
                height: { xs: 240, sm: 400 },
                borderRadius: 2,
                overflow: "hidden",
                bgcolor: "#f3f4f6",
                // border: "1px solid #e5e7eb",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src="/assets/images/logo-with-bg.jpeg"
                alt="صورة المدير العام (سيتم تحديثها لاحقًا)"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Box>
          </Box>

          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              textAlign: "center",
              fontSize: { xs: "1.4rem", sm: "1.8rem" },
            }}
          >
            نلهم العظمة
          </Typography>

          <Typography sx={{ fontSize: { xs: "1rem", sm: "1.1rem" }, lineHeight: 2 }}>
            مرحبًا بك في <strong>منصتك</strong>، حيث تبدأ الرحلة نحو مستوى جديد من
            التأثير، القيادة، والتطور.
          </Typography>

          <Typography sx={{ fontSize: { xs: "1rem", sm: "1.1rem" }, lineHeight: 2 }}>
            في <strong>شركة آفاق بلا حدود للتدريب والاستشارات</strong> نؤمن بأن
            العظمة لا تأتي صدفة، بل تُصنع. يصنعها أولئك الذين قرروا أن يطوروا
            أنفسهم باستمرار، أن يقودوا الآخرين نحو الأفضل، وأن يبنوا علاقات
            تفتح أبوابًا وفرصًا لا تُقاس بالأرقام فقط، بل بالأثر الحقيقي.
          </Typography>

          <Typography sx={{ fontSize: { xs: "1rem", sm: "1.1rem" }, lineHeight: 2 }}>
            سواء كنت <strong>رائد أعمال</strong> تسعى لنقل فكرتك إلى سوق مليء
            بالتحديات، أو <strong>قائد فريق</strong> توسّع رؤيتك، أو شخصية
            مؤثرة تطمح لأن تترك أثرًا اجتماعيًا حقيقيًا... هذه المنصة خُلقت
            لأمثالك.
          </Typography>

          <Typography sx={{ fontSize: { xs: "1rem", sm: "1.1rem" }, lineHeight: 2 }}>
            نحن لا نراك مجرد متعلم، بل نراك قائدًا قادرًا على بناء فرق، علاقات،
            ومجتمعات أقوى. <strong>“نلهم العظمة”</strong> تعني أننا نصمم كل
            دورة وكل تجربة لتمنحك أكثر من المعرفة؛ لتبني فيك الحضور، المهارات
            القيادية، وفن التواصل الفعال مع الناس، مقرونًا بالذكاء العاطفي.
          </Typography>

          <Typography sx={{ fontSize: { xs: "1rem", sm: "1.1rem" }, lineHeight: 2 }}>
            في هذا المكان، لا يهم من أين تبدأ، بل الأهم إلى أين تريد أن تصل. ابدأ
            اليوم. طوّر مهاراتك. وسّع علاقاتك. قُد من حولك. واترك بصمتك. نحن
            معك، <strong>خطوة بخطوة</strong>.
          </Typography>

          <Stack sx={{ textAlign: "center", mt: 4 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", fontSize: { xs: "1.1rem", sm: "1.3rem" } }}
            >
              بتقدير واحترام،
            </Typography>
            <Typography sx={{ fontWeight: "bold", fontSize: { xs: "1.1rem", sm: "1.3rem" } }}>
              حسام عطايا
            </Typography>
            <Typography sx={{ color: "text.secondary" }}>
              المدير العام – شركة آفاق بلا حدود للتدريب والاستشارات
            </Typography>
            <Typography sx={{ color: "text.secondary" }}>دمشق – سوريا</Typography>
          </Stack>
        </Stack>
      </div>
    </div>
  );
};

export default GeneralManagerMessageAr;
